import React from "react"

import { Box, Image, Typography } from "src/UILibrary"
import { useTranslation } from "react-i18next"
import { Event } from "src/openapi"
import { APPLICATION_STATUS, EVENT_STATUS } from "src/modules/const"
import ClockSVG from "src/assets/icons/clock.svg"
import LocationSVG from "src/assets/icons/location.svg"
import { useLoginContext } from "src/hooks/useLoginContext"
import { getLabel } from "src/modules/helper"

type Prop = {
  item: Event
  handleSelected: any
}

export const EventItem = ({ item, handleSelected }: Prop) => {
  const { t } = useTranslation("translation", { keyPrefix: "event" })

  const { areas } = useLoginContext()

  const getApplicationCount = () => {
    if (!item.eventApplications) {
      return 0
    }

    let count = 0
    for (const application of item.eventApplications) {
      if (application.application?.status === APPLICATION_STATUS.RESERVED) {
        count++
      }
    }
    return count
  }

  return (
    <Box
      width="100%"
      display="flex"
      flexDirection="column"
      sx={{
        p: "10px",
        bgcolor: "white",
        ":hover": { opacity: 0.8, cursor: "pointer" },
      }}
      onClick={() => handleSelected(item)}
    >
      <Image
        src={item.imageUrl as string}
        sx={{ height: 160, width: "100%", bgcolor: "divider" }}
        alt=""
        imageStyle={{ width: "100%", height: "100%" }}
      />
      {item.status === EVENT_STATUS.STARTED && (
        <Box sx={{ px: "10px", py: "6px", bgcolor: "#57C0E7", position: "absolute" }}>
          <Typography.ExtraSmallText sx={{ color: "white" }}>
            {t("started")}
          </Typography.ExtraSmallText>
        </Box>
      )}
      {item.status === EVENT_STATUS.RECEIVING && (
        <Box sx={{ px: "10px", py: "6px", bgcolor: "#ED8C81", position: "absolute" }}>
          <Typography.ExtraSmallText sx={{ color: "white" }}>
            {t("receiving")}
          </Typography.ExtraSmallText>
        </Box>
      )}
      {item.status === EVENT_STATUS.ARCHIVED && (
        <Box sx={{ px: "10px", py: "6px", bgcolor: "#235496", position: "absolute" }}>
          <Typography.ExtraSmallText sx={{ color: "white" }}>
            {t("archived")}
          </Typography.ExtraSmallText>
        </Box>
      )}
      <Box display="flex" sx={{ mt: "10px" }}>
        <Typography.DetailText
          sx={{
            fontFamily: "Noto Sans JP !important",
            color: "text.primary",
          }}
        >
          {`${item.startTime?.slice(0, 10)}`}
        </Typography.DetailText>
        <Box display="flex" sx={{ ml: "10px" }}>
          <Image src={ClockSVG} sx={{ lineHeight: "16px" }} />
          <Typography.DetailText sx={{ fontFamily: "Noto Sans JP !important", ml: "5px" }}>
            {item.startTime?.slice(11, 16)}-{item.finishTime?.slice(11, 16)}
          </Typography.DetailText>
        </Box>
        <Box display="flex" sx={{ ml: "10px" }}>
          <Image src={LocationSVG} sx={{ lineHeight: "16px" }} />
          <Typography.DetailText sx={{ fontFamily: "Noto Sans JP !important", ml: "5px" }}>
            {getLabel(areas, item.areaId as number)}
          </Typography.DetailText>
        </Box>
      </Box>
      <Typography.DetailText sx={{ fontFamily: "Noto Sans JP !important" }}>
        {`定員 ${item.applicationMax}名/${getApplicationCount()}名`}
      </Typography.DetailText>
      <Typography.SubTitleNormal
        sx={{
          fontFamily: "Noto Sans JP !important",
          mt: "10px",
          display: "-webkit-box",
          overflow: "hidden",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
        }}
      >
        {item.title}
      </Typography.SubTitleNormal>
    </Box>
  )
}
